import {gql} from "@apollo/client";

export const GET_ZONE = gql`
  query DeliveryQuery($originZipcode: String!,
                    $targetZipcode: String!) {
    getZone(originZipcode:$originZipcode,
            targetZipcode:$targetZipcode)
  }
`;

